<template>
  <div>
    <a-modal v-model="scrapVisible" :title="$t('page_work_scrap_details')" width="850px"
             @cancel="handleCancel">
      <template v-slot:footer>
        <a-button @click="save">{{ $t('save') | i18n }}</a-button>
      </template>
      <a-row>
        <a-col :span="12" class="scrap-top">
          <span class="label">{{$t('page_work_order_qulify_num')}}：</span>
          <a-input-number :min="0" v-model="qualifyNum" style="width: 200px;"/>
        </a-col>
        <a-col :span="12" class="scrap-top">
        <span class="label">{{$t('page_work_order_scrapped_num')}}：</span>
          <a-input-number :min="0" v-model="scrappedNum" style="width: 200px;"/>
        </a-col>
        <a-col :span="12" class="scrap-top">
          <span class="label">{{$t('remark')}}：</span>
            <a-input v-model="remark" style="width:200px"/>
        </a-col>
        <a-col :span="12" class="scrap-top" v-for="col in extraForms" :key="col.code">
          <span class="label">{{col.title}}：</span>
            <a-input v-model="col.value" style="width:200px"/>
        </a-col>
      </a-row>

      <div>
        <a-button style="width:100%;" @click="() => this.addScrap()">{{$t('page_add_scrap')}}</a-button>
      </div>
      <ml-table
              size="small"
              :bordered="true"
              :columns="columns"
              :dataSource="data"
              :pagination="false"
              rowKey="id"
              style="margin-bottom: 4px"
      >
        <template slot="scrappedNum" slot-scope="text, record">
          <a-input-number
                  style="margin: -5px 0;width: 200px"
                  :value="text"
                  :min="0"
                  @change="(value) => handleChange(value, record.key, 'scrappedNum')"
          />
        </template>
        <template slot="scrappedType" slot-scope="text, record">
          <a-select
                  show-search
                  optionFilterProp="children"
                  :value="record.scrappedTypeCode"
                  style="width: 200px"
                  @change="(e) => handleChange(e, record.key, 'scrappedType')"
          >
            <template v-for="(res, index) in scrapType">
              <a-select-option :key="index" :value="res.code"
              >{{ res.name }}-{{ res.code }}
              </a-select-option
              >
            </template>
          </a-select>
        </template>
        <template slot="scrappedReason" slot-scope="text, record">
          <a-select
                  show-search
                  optionFilterProp="children"
                  :value="record.scrappedCodeAndReason"
                  style="width: 200px"
                  @dropdownVisibleChange="() => getReasons(record)"
                  @change="(e) => handleChange(e, record.key, 'scrappedReason')"
          >
            <template v-for="(res, index) in record.scrapReasons">
              <a-select-option :key="index" :value="res.code"
              >{{ res.reason }}-{{ res.code }}
              </a-select-option
              >
            </template>
          </a-select>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-popconfirm
                  :title="$t('page_resource_pool_confirm_delete')"
                  @confirm="() => handleDelete(record)"
                  :okText="$t('yes')"
                  :cancelText="$t('no')"
          >
            <a type="link" @click="(e) => e.stopPropagation()" class="del-color">
              {{ $t('delete') }}
            </a>
          </a-popconfirm>
        </template>
      </ml-table>
    </a-modal>
  </div>
</template>
<script>
// import ScrapTable from './ScrapTable.vue'
import { ScrappedReasonServiceProxy } from '@/service-proxies/app-v2/qc.service-proxies'
import { ProductionOrderProcessWorkStationRecordServiceProxy } from '@/service-proxies/app-v2/coproduction.service-proxies'

const popwsr = new ProductionOrderProcessWorkStationRecordServiceProxy()
const srsp = new ScrappedReasonServiceProxy()
const columns = [
  {
    title: '报废数量',
    dataIndex: 'scrappedNum',
    scopedSlots: { customRender: 'scrappedNum' }
  },
  {
    title: '报废类型',
    dataIndex: 'scrappedType',
    scopedSlots: { customRender: 'scrappedType' }
  },
  {
    title: '报废原因',
    dataIndex: 'scrappedReason',
    scopedSlots: { customRender: 'scrappedReason' }
  },
  {
    title: '操作',
    width: 100,
    scopedSlots: { customRender: 'action' }
  }
]
export default {
  data () {
    return {
      data: [],
      count: 1,
      scrapReasons: [],
      columns,
      qualifyNum: 0,
      scrappedNum: 0,
      scrappedNum1: 0,
      remark: '',
      extraForms: []
    }
  },
  props: {
    scrapVisible: {
      type: Boolean,
      default: false
    },
    scrapType: {
      type: Array,
      default: () => []
    },
    extraCols: { // 自定义字段
      type: Array,
      default: () => []
    },
    record: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    extraCols (val) {
      let temp = []
      val.map(item => {
        temp.push({
          title: item.title,
          code: item.dataIndex,
          value: this.record[item.dataIndex]
        })
      })
      this.extraForms = temp
    },
    scrapVisible (val) {
      if (val) {
        this.qualifyNum = this.record.qualifyNum
        this.scrappedNum = this.record.scrappedNum
        this.remark = this.record.remark
        let temp = []
        this.extraCols.map(item => {
          temp.push({
            title: item.title,
            code: item.dataIndex,
            value: this.record[item.dataIndex]
          })
        })
        this.extraForms = temp
        this.getList()
      }
    }
  },
  methods: {
    async getList () {
      await popwsr.workStationScrappedRecord(this.record.id).then(res => {
        this.data = res
        this.data.map(item => {
          item.key = this.count + 'add'
          item.scrapReasons = []
          this.count += 1
          this.scrappedNum1 += item.scrappedNum
        })

      })
    },
    handleChange (value, key, column) {
      this.scrappedNum1 = 0
      const newData = [...this.data]
      const target = newData.filter((item) => key === item.key)[0]

      if (target) {
        if (column === 'scrappedType') {
          const type = this.scrapType.find((res) => res.code === value)
          target['scrappedTypeCode'] = type.code
          target[column] = type.name
          target['scrappedReason'] = ''
          target['scrappedReasonCode'] = ''
          target['scrappedCodeAndReason'] = ''
        } else if (column === 'scrappedReason') {
          const reasons = target.scrapReasons.find((res) => res.code === value)
          target['scrappedReasonCode'] = reasons.code
          target['scrappedCodeAndReason'] = reasons.code + '-' + reasons.reason
          target[column] = reasons.reason
        } else {
          target[column] = value
        }
        this.data = newData
        this.data.map((item, i) => {
          this.scrappedNum1 += this.data[i].scrappedNum * 1
        })
      }
    },
    async getReasons (record) {
      const type = this.scrapType.find((res) => res.code === record.scrappedTypeCode)
      if (type) {
        const res = await srsp.qcGetPageScrappedReason(1, -1, type.id)
        record.scrapReasons = res.records
        this.data = [...this.data]
      }
    },
    handleDelete (record) {
      const dataSource = [...this.data]
      this.data = dataSource.filter((item) => item.key !== record.key)
      this.scrappedNum1 -= record.scrappedNum
    },

    addScrap () {
      const dataSource = [...this.data]
      const newData = {
        key: this.count + 'add',
        scrappedNum: 0,
        scrappedReason: '',
        scrappedReasonCode: '',
        scrappedType: '',
        scrappedTypeCode: '',
        scrapReasons: []
      }
      this.count += 1
      this.data = [...dataSource, newData]
    },
    async save () {
      const body = {
        qualifyNum: this.qualifyNum,
        recordId: this.record.id,
        scrappedNum: this.scrappedNum,
        remark: this.remark,
        workStationScrappedRecordDTOList: this.data
      }
      if (this.scrappedNum1 > this.scrappedNum) {
        this.$message.error('明细报废数总数需小于或等于报废数')
      } else {
        await popwsr.updateRecordReportWork(body)
        this.$message.success(this.$t('page_work_report_success'))
        this.scrappedNum = 0
        this.qualifyNum = 0
        this.scrappedNum1 = 0
        this.data = []
        this.$emit('saveScrap')
        this.$emit('scrapCancel')
      }
    },
    handleCancel () {
      this.scrappedNum = 0
      this.qualifyNum = 0
      this.$emit('scrapCancel')
    }
  }
}
</script>
<style lang="less">
  .editable-add-btn {
    margin-top: 10px;
    width: 150px;
    border: 0;
  }

  .scrap-top {
    margin-bottom: 10px;

    .label {
      min-width: 180px;
      display: inline-block;
      text-align: right;
    }
  }
</style>
